module.exports = {"TRE":{"users":{"title":"documentation.label.help.users","subSection":"Administração-usuários_","docId":"784208873"}},"TOL":{}}